import Text from "../../shared/text/Text";
import HeroImage from "./HeroImage";
import styles from "./ClaimOwnershipModal.module.scss";

const SuccessBody = ({ body }) => {
  const { title, subtitle, imageUrl } = body ?? {};

  return (
    <section className={styles.successContainer}>
      <HeroImage imageUrl={imageUrl} variant="full" />
      <Text uiData={title} className={styles.successTitle} />
      <Text uiData={subtitle} className={styles.successSubtitle} />
    </section>
  );
};

export default SuccessBody;
